export default __webpack_public_path__ + "static/media/abeille1.0367a6f5.jpg";